var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterTheFireAndLifeSafetySystemOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 47,
    viewBox: "0 0 70 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26048 17.357C9.4832 20.724 7.85291 24.4104 7.85291 24.4104C7.85291 24.4104 4.24043 22.6375 3.01772 19.2682C1.795 15.9012 3.42529 12.2148 3.42529 12.2148C3.42529 12.2148 7.03776 13.9877 8.26048 17.357Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0667 8.01097C15.0667 11.4517 11.579 13.459 11.579 13.459C11.579 13.459 9.71038 9.88875 10.7104 6.44801C11.7104 3.00728 15.1981 1 15.1981 1C15.1981 1 17.0667 4.57024 16.0667 8.01097Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79287 30.4955C10.5813 32.7395 11.0935 36.7384 11.0935 36.7384C11.0935 36.7384 7.08686 37.1001 4.30067 34.8562C1.51225 32.6122 1 28.6133 1 28.6133C1 28.6133 5.00668 28.2516 7.79287 30.4955Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9955 40.2907C19.5679 40.4069 22.3742 43.2961 22.3742 43.2961C22.3742 43.2961 19.3875 45.9978 15.8151 45.8817C12.2428 45.7656 9.43652 42.8763 9.43652 42.8763C9.43652 42.8763 12.4232 40.1746 15.9955 40.2907Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6256 17.357C60.4029 20.724 62.0332 24.4104 62.0332 24.4104C62.0332 24.4104 65.6457 22.6375 66.8684 19.2682C68.0911 15.9012 66.4608 12.2148 66.4608 12.2148C66.4608 12.2148 62.8483 13.9877 61.6256 17.357Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8198 8.01097C54.8198 11.4517 58.3075 13.459 58.3075 13.459C58.3075 13.459 60.1761 9.88875 59.1761 6.44801C58.1761 3.00728 54.6883 1 54.6883 1C54.6883 1 52.8198 4.57024 53.8198 8.01097Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0936 30.4955C59.3052 32.7395 58.793 36.7384 58.793 36.7384C58.793 36.7384 62.7997 37.1001 65.5858 34.8562C68.3743 32.6122 68.8865 28.6133 68.8865 28.6133C68.8865 28.6133 64.8798 28.2516 62.0936 30.4955Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8908 40.2907C50.3184 40.4069 47.5122 43.2961 47.5122 43.2961C47.5122 43.2961 50.4988 45.9978 54.0712 45.8817C57.6436 45.7656 60.4498 42.8763 60.4498 42.8763C60.4498 42.8763 57.4632 40.1746 53.8908 40.2907Z",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9379 7.59375C34.9379 7.59375 40.9624 12.8966 48.2207 12.0727V28.2739C48.2207 35.0013 35.1072 41.0923 35.1072 41.0923C35.1072 41.0923 21.9268 35.4121 21.9268 28.2739V12.0727C29.8689 12.8966 34.9357 7.59375 34.9357 7.59375",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1581 20.8271L33.706 27.7064L29.9443 24.0558",
    stroke: "#257239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterTheFireAndLifeSafetySystemOverview);
export default __webpack_public_path__ + "static/media/register-the-fire-and-life-safety-system-overview.54518dcd0648feafaa934bca21298b6c.svg";
export { ForwardRef as ReactComponent };